<div class="container">
    <img id="alien" class="responsive-img img-header animated pulse" src="assets/img/logo_loading.png"/>
</div>
<div class="container">
    <form class="four-oh-four-form">
        <input class="404-input" type="text" value="">
    </form>
    
    <p class="title animated zoomIn">
        Error 404
    </p>
    <div class="terminal">
        <p class="prompt">
            La página no se encuentra, prueba escribiendo 'romaef' y enter para ejecutar.
        </p>
        <p class="prompt output new-output">
        </p>
    </div>
</div>
